import { useEffect, useRef, useState } from "react";
import { Play, Pause, RotateCcw } from "lucide-react";

const TrialTimer = () => {
  const [secondsLeft, setSecondsLeft] = useState(15 * 60);
  const [running, setRunning] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (running) {
      intervalRef.current = setInterval(() => {
        setSecondsLeft((s) => {
          if (s <= 1) {
            setRunning(false);
            return 0;
          }
          return s - 1;
        });
      }, 1000);
    }
    return () => clearInterval(intervalRef.current);
  }, [running]);

  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const display = `${minutes}:${String(seconds).padStart(2, "0")}`;
  const finished = secondsLeft === 0;

  return (
    <div data-testid="trial-timer" className="bg-white rounded-2xl border border-border shadow-[0_4px_20px_rgba(0,0,0,0.05)] p-8 sm:p-10 text-center">
      <p className="text-sm uppercase tracking-widest font-semibold text-gold-dark mb-3">15-minute reset window</p>
      <p
        data-testid="timer-display"
        aria-live="polite"
        className={`font-heading font-black text-7xl sm:text-8xl tracking-tight mb-2 ${finished ? "text-gold-dark" : "text-sage"}`}
      >
        {display}
      </p>
      <p className="text-base text-ink/60 mb-8">
        {finished ? "Time! One small step counts." : "Less or more is fine — this is just a friendly window."}
      </p>
      <div className="flex justify-center gap-4">
        <button
          type="button"
          onClick={() => setRunning((r) => !r)}
          disabled={finished}
          data-testid="timer-start-pause-button"
          className="inline-flex items-center gap-2 bg-sage text-white hover:bg-sage-dark rounded-full px-8 py-4 text-lg font-medium transition-all duration-300 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-sage focus:ring-offset-2"
        >
          {running ? <Pause className="h-5 w-5" aria-hidden="true" /> : <Play className="h-5 w-5" aria-hidden="true" />}
          {running ? "Pause" : "Start"}
        </button>
        <button
          type="button"
          onClick={() => { setRunning(false); setSecondsLeft(15 * 60); }}
          data-testid="timer-reset-button"
          className="inline-flex items-center gap-2 border-2 border-sage text-sage hover:bg-sage hover:text-white rounded-full px-8 py-4 text-lg font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-sage focus:ring-offset-2"
        >
          <RotateCcw className="h-5 w-5" aria-hidden="true" /> Reset
        </button>
      </div>
    </div>
  );
};

export default TrialTimer;
